import React, { useEffect, useState } from "react";
import { Button, Input, Row, TimePicker } from "antd";
import "../comp-styles/ConfiguracionCitas.scss";
import {
  ContenedorBotonCentrado,
} from "../GeneralComponents/Formularios2Grids";
import { useNavigate, Link } from "react-router-dom";
//import Confcitas from "../GeneralComponents/General-Json";
import Eliminar from "../../Img/Iconos/eliminar.svg";
import {
  getConfigCitas_request,
  getBlockDates_request,
  saveConfigCita_request,
  saveBlockDates_request,
  deleteBlockDates_request,
} from "../../services/citas_services";
// import * as moment from 'moment';
import dayjs from "dayjs";

// iconos
import Iconos from "../IconosDeSitio";
import LockClockIcon from '@mui/icons-material/LockClock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Label } from "../GeneralComponents/Formularios";
import { Loader } from "../GeneralComponents/Loader";
import SelectAntd from "../GeneralComponents/SelectAntd";
import { Content } from "antd/es/layout/layout";
import ButtonAntd from "../GeneralComponents/ButtonAntd";
import NewNavbar from "../GeneralComponents/Navbar_Nuevo";
import AppointmentDateControl from './AppointmentDateControl';
import {
  FormControlLabel,
  Switch,
  Checkbox as MUICheckbox,
  Box,
} from '@mui/material';

// const onChange = (e) => {
// console.log(`checked = ${e.target.checked}`);
// };

const checkboxColorStyle = {
  color: '#148f9f',
  '&.Mui-checked': {
    color: '#148f9f',
  },
};

const swtichColorStyle = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#148f9f', // color del thumb (círculo)
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#148f9f', // color del track (fondo deslizante)
  },
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ConfiguracionCitas() {
  //const navigate = useNavigate();

  // Declaracion de select para <p></p>rio
  const [TipoDeHorario, setTipoDeHorario] = useState("0");

  //Declaracion los dias de la semana
  const [DuracionCita, setDuracionCita] = useState("");

  const [HoraCita, setHoraCita] = useState("");
  const [MinutosCita, setMinutosCita] = useState("");

  const [Lunes, setLunes] = useState(false);
  const [Martes, setMartes] = useState(false);
  const [Miercoles, setMiercoles] = useState(false);
  const [Jueves, setJueves] = useState(false);
  const [Viernes, setViernes] = useState(false);
  const [Sabado, setSabado] = useState(false);
  const [Domingo, setDomingo] = useState(false);

  //Nuevos horarios de semana
  const [mondayHours, setMondayHours] = useState([]);
  const [tuesdayHours, setTuesdayHours] = useState([]);
  const [wednesdayHours, setWednesdayHours] = useState([]);
  const [thursdayHours, setThursdayHours] = useState([]);
  const [fridayHours, setFridayHours] = useState([]);
  const [saturdayHours, setSaturdayHours] = useState([]);
  const [sundayHours, setSundayHours] = useState([]);

  const [anotherSchedule, setAnotherSchedule] = useState(false);
  const [anotherStartDay, setAnotherStartDay] = useState();
  const [anotherEndDay, setAnotherEndDay] = useState();

  // Nuevos horarios de semana
  const [Semana, setSemana] = useState(false);
  const [HorarioInicioSemana, setHorarioInicioSemana] = useState("");
  const [HorarioFinSemana, setHorarioFinSemana] = useState("");

  const [ListBlockDates, setListBlockDates] = useState([]);

  const [FechaInicio, setFechaInicio] = useState("");
  const [FechaFin, setFechaFin] = useState("");

  // MANEJO DE MENSAJES
  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(false);

  const [MensajeDuracionCita, setMensajeDuracionCita] = useState("true");

  async function getConfigCitas() {
    const keyDays = { MO: 'monday', TU: 'tuesday', WE: 'wednesday', TH: 'thursday', FR: 'friday', SA: 'saturday', SU: 'sunday' };

    setLoader(true);
    let response = await getConfigCitas_request();
    if (response.ok) {
      if (response.data.TipoHorario !== null) {
        setTipoDeHorario(response.data.TipoHorario.toString());
        setSemana(response.data.TipoHorario === 1 ? true : false);

      }
      setDuracionCita(response.data.TiempoCita.toString());

      if (response.data.TipoHorario === 1) {
        const diasClave = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
        const activeKey = diasClave.find(dia => response.data[dia] === 1);
        const times = response.data[keyDays[activeKey]];

        if (times) {
          setHorarioInicioSemana(times[0].startTime);
          setHorarioFinSemana(times[0].endTime);
        }

        if (times && times.length > 1) {
          setAnotherSchedule(true);
          setAnotherStartDay(times[1].startTime);
          setAnotherEndDay(times[1].endTime);
        }
      }

      setLunes(response.data.MO === 1 ? true : false);
      setMondayHours(response.data.monday);

      setMartes(response.data.TU === 1 ? true : false);
      setTuesdayHours(response.data.tuesday);

      setMiercoles(response.data.WE === 1 ? true : false);
      setWednesdayHours(response.data.wednesday);

      setJueves(response.data.TH === 1 ? true : false);
      setThursdayHours(response.data.thursday);

      setViernes(response.data.FR === 1 ? true : false);
      setFridayHours(response.data.friday);

      setSabado(response.data.SA === 1 ? true : false);
      setSaturdayHours(response.data.saturday);

      setDomingo(response.data.SU === 1 ? true : false);
      setSundayHours(response.data.sunday);
    } else {
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
    setLoader(false);
    return;
  }

  async function getBlockDates() {
    let response = await getBlockDates_request();
    if (response.ok) {
      setListBlockDates(response.data);
    } else {
      setListBlockDates([]);
    }
  }

  const guardarConfigCita = async (e) => {
    setLoader(true);
    let save = true;
    const dayFlags = {
      monday: {
        active: Lunes,
        fields: mondayHours,
        textField: 'mondayHours',
        textDay: 'Lunes'
      },
      tuesday: {
        active: Martes,
        fields: tuesdayHours,
        textField: 'tuesdayHours',
        textDay: 'Martes'
      },
      wednesday: {
        active: Miercoles,
        fields: wednesdayHours,
        textField: 'wednesdayHours',
        textDay: 'Miercole'
      },
      thursday: {
        active: Jueves,
        fields: thursdayHours,
        textField: 'thursdayHours',
        textDay: 'Jueves'
      },
      friday: {
        active: Viernes,
        fields: fridayHours,
        textField: 'fridayHours',
        textDay: 'Viernes,'
      },
      saturday: {
        active: Sabado,
        fields: saturdayHours,
        textField: 'saturdayHours',
        textDay: 'Sabado'
      },
      sunday: {
        active: Domingo,
        fields: sundayHours,
        textField: 'sundayHours',
        textDay: 'Domingo'
      }
    };
    const validateDays = Lunes || Martes || Miercoles || Jueves || Viernes || Sabado || Domingo;
    if (validateDays) {
      if (DuracionCita !== "00" && DuracionCita !== "") {
        let data = new FormData();

        data.append("TiempoCita", DuracionCita);
        data.append("tipoHorario", !!TipoDeHorario ? TipoDeHorario : 0);

        if (Semana) {
          Object.entries(dayFlags).forEach(([key, value]) => {
            let availableTimes = [{ startTime: HorarioInicioSemana, endTime: HorarioFinSemana}];
            if (anotherSchedule) {

              if (validateTimes(availableTimes[0], { startTime: anotherStartDay, endTime: anotherEndDay })) {
                save = false;
                setOpen(true);
                setTypeMessage("warning");
                setMessage(`El horario del día ${value.textDay}, se sobrepone con el primero.`);
              } else {
                availableTimes.push({ startTime: anotherStartDay, endTime: anotherEndDay })
              }
            }

            if (value.active) {
              data.append(key, value.active);
              data.append(`${key}Hours`, JSON.stringify(availableTimes));
            }
          });
        } else {
          Object.entries(dayFlags).forEach(([key, value]) => {
            if (!value.active) return;

            if (value.fields.length > 1) {
              if (validateTimes(value.fields[0], value.fields[1])) {
                save = false;
                setOpen(true);
                setTypeMessage("warning");
                setMessage(`Los horarios del día ${value.textDay} se sobreponen. Elija un horario diferente.`);
              } else {
                if (value.active) {
                  data.append(key, value.active);
                  data.append(value.textField,  JSON.stringify(value.fields));
                }
              }
            } else {
                if (value.active) {
                  data.append(key, value.active);
                  data.append(value.textField,  JSON.stringify(value.fields));
                }
            }
          });
        }

        if(save) {
          let response = await saveConfigCita_request(data);
          if (response.ok) {
            setOpen(true);
            setTypeMessage("success");
            setMessage("Configuracion guardada");
            getConfigCitas();
          } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
          }
          setLoader(false);
        }
      } else {
        setOpen(true);
        setTypeMessage("warning");
        setMessage("Debe elegir un tiempo de cita");
      }
    } else {
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Debe poner al menos un horario");
    }
    setLoader(false);
    return;
  };

  const guardarPeriodoBloqueado = async (e) => {
    e.preventDefault();
    setLoader(true);
    let data = new FormData();
    data.append("FechaInicio", FechaInicio);
    data.append("FechaFin", FechaFin);
    if (FechaInicio !== "" && FechaFin !== "") {
      let response = await saveBlockDates_request(data);
      if (response.ok) {
        setOpen(true);
        setTypeMessage("success");
        setMessage("Periodo bloqueada");
        setFechaInicio("");
        setFechaFin("");
        getBlockDates();
      } else {
        setOpen(true);
        setTypeMessage("error");
        setMessage(response.mensaje);
      }
    } else {
      setOpen(true);
      setTypeMessage("warning");
      setMessage("Debes llenar ambas fechas");
    }
    setLoader(false);
    return;
  };

  async function deleteBlockDates(idBloqueo) {
    setLoader(true);
    let response = await deleteBlockDates_request(idBloqueo);
    if (response.ok) {
      setOpen(true);
      setTypeMessage("success");
      setMessage("Periodo eliminado");
      getBlockDates();
    } else {
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
    setLoader(false);
    return;
  }

  useEffect(() => {
    getConfigCitas();
    getBlockDates();
    // return;
  }, []);

  const handleChangeDay = (data) => {
    if (data.day === 'monday') {
      setMondayHours(data.availableTimes);
      setLunes(data.isActive);
    } else if (data.day === 'tuesday') {
      setTuesdayHours(data.availableTimes);
      setMartes(data.isActive);
    } else if (data.day === 'wednesday') {
      setWednesdayHours(data.availableTimes);
      setMiercoles(data.isActive);
    } else if (data.day === 'thursday') {
      setThursdayHours(data.availableTimes);
      setJueves(data.isActive);
    } else if (data.day === 'friday') {
      setFridayHours(data.availableTimes);
      setViernes(data.isActive);
    } else if (data.day === 'saturday') {
      setSaturdayHours(data.availableTimes);
      setSabado(data.isActive);
    } else if (data.day === 'sunday') {
      setSundayHours(data.availableTimes);
      setDomingo(data.isActive);
    }
  };

  const handleChangeSwitch = (e)=>{
    setAnotherSchedule(e.target.checked);

    setAnotherStartDay(HorarioFinSemana);
    setAnotherEndDay("11:59 PM");
  };

  const validateTimes = (one, two) => {
    const start1 = timeToMinutes(one.startTime);
    const end1 = timeToMinutes(one.endTime);
    const start2 = timeToMinutes(two.startTime);
    const end2 = timeToMinutes(two.endTime);

    return start1 < end2 && start2 < end1;
  }

  const timeToMinutes = (timeStr) => {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes;
  }

  return (
    <Stack>
      <NewNavbar
        showBanner={false}
        mensajesError={{
          setOpen: setOpen,
          setTypeMessage: setTypeMessage,
          setMessage: setMessage,
        }}
        searchBar={
          <div className="BackConfigStyle">
            <Link to="/app/Citas">
              <img className="iconBack" src={Iconos[23]} alt="" />
            </Link>
            <b style={{ fontSize: "150%" }}>Horario de citas</b>
          </div>
        }
      />
      <Content
        className="site-layout"
        style={{
          padding: "0 3%",
          width: "100%",
          overflow: "initial",
        }}
      >
        {loader ? (
          <Loader />
        ) : (
          <>
            <div>
              <div style={{ padding: "1%" }}>
                <Row>
                  <Row>
                    <label htmlFor="">Selecciona tu tipo de horario:</label>
                    <select
                      onChange={(e) => {
                        setTipoDeHorario(e.target.value);
                        if (e.target.value === "1") {
                          setSemana(true);
                          setTipoDeHorario("1");
                        } else {
                          setSemana(false);
                          setHorarioInicioSemana("");
                          setHorarioFinSemana("");
                          setTipoDeHorario("0");
                        }
                        // console.log(e.target.value);
                      }}
                      // defaultValue={TipoDeHorario}
                      value={TipoDeHorario}
                      name=""
                      id="HorarioTipo"
                      className="inputblue"
                      style={{
                        borderRadius: ".4rem",
                        width: "75%",
                        height: "35px",
                        padding: "0%",
                      }}
                    >
                      <option
                        style={{ color: "#148f9f" }}
                        value=""
                        defaultChecked
                        disabled
                      >
                        Seleciona una opcion
                      </option>
                      <option value="0">Config.Horario por dia</option>
                      <option value="1">Config.Horario por semana</option>
                    </select>
                  </Row>
                </Row>
              </div>
            </div>
            {TipoDeHorario === "0" ? (
              <div className="confcitas">
                {/* { SelecionadoTipo === 0 ? <div>POR DIA</div> : <div>pOR SEMANA</div>} */}
                <form>
                  <Row style={{ justifyContent: "space-between" }}>
                    <AppointmentDateControl day={'monday'} text={'Lunes'} onHandleChange={handleChangeDay} initialData={{ isActive: Lunes, day: mondayHours }} />
                    <AppointmentDateControl day={'tuesday'} text={'Martes'} onHandleChange={handleChangeDay} initialData={{ isActive: Martes, day: tuesdayHours }} />
                    <AppointmentDateControl day={'wednesday'} text={'Miércoles'} onHandleChange={handleChangeDay} initialData={{ isActive: Miercoles, day: wednesdayHours }} />
                  </Row>
                  <hr />
                  <br />
                  <Row style={{ justifyContent: "space-between" }}>
                    <AppointmentDateControl day={'thursday'} text={'Jueves'} onHandleChange={handleChangeDay} initialData={{ isActive: Jueves, day: thursdayHours }}/>
                    <AppointmentDateControl day={'friday'} text={'Viernes'} onHandleChange={handleChangeDay} initialData={{ isActive: Viernes, day: fridayHours }} />
                    <AppointmentDateControl day={'saturday'} text={'Sábado'} onHandleChange={handleChangeDay} initialData={{ isActive: Sabado, day: saturdayHours }}/>
                  </Row>
                  <hr />
                  <br />
                  <Row style={{ justifyContent: "space-between" }}>
                    <AppointmentDateControl day={'sunday'} text={'Domingo'} onHandleChange={handleChangeDay} initialData={{ isActive: Domingo, day: sundayHours }}/>
                    <div style={{ width: "37%" }}>
                      <div>
                        <SelectAntd
                          label="Tiempo de cita:"
                          placeholder="Elige un tiempo de cita"
                          options={[
                            { value: "10", label: "10 Min." },
                            { value: "20", label: "20 Min." },
                            { value: "30", label: "30 Min." },
                            { value: "40", label: "40 Min." },
                            { value: "50", label: "50 Min." },
                            { value: "60", label: "1 Hr." },
                            // { value: "70", label: "1 Hr. 10 Min." },
                            // { value: "80", label: "1 Hr. 20 Min." },
                            // { value: "90", label: "1 Hr. 30 Min." },
                            // { value: "100", label: "1 Hr. 40 Min." },
                            // { value: "110", label: "1 Hr. 50 Min." },
                            // { value: "120", label: "2 Hrs." },
                          ]}
                          style={{ width: "100%", fontWeight: "normal" }}
                          setStateValue={setDuracionCita}
                          value={DuracionCita}
                          setStateError={setMensajeDuracionCita}
                          valueError={MensajeDuracionCita}
                          vacio={false}
                        />
                      </div>
                    </div>
                  </Row>
                  <br />
                  <br />
                  {/* <hr /> */}
                  <br />
                  <ContenedorBotonCentrado>
                    {/* <button type="submit" className="GeneralBoton">
                      Guardar
                    </button> */}
                    <ButtonAntd

                      onClick={() => {
                        guardarConfigCita();
                      }}
                    >

                      <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80px" }}>
                        Guardar
                        <CheckCircleIcon style={{ fontSize: "15px" }} />
                      </Row>
                    </ButtonAntd>
                  </ContenedorBotonCentrado>
                </form>
              </div>
            ) : (
              <div style={{ padding: "1% 2%", width: "100%", background: "#fff", borderRadius: ".5rem", marginBottom: "10px" }}>
                <form>
                  <div>
                    <div style={{ textAlign: "center", margin: "1%" }}>
                      <h2>Selecciona los días hábiles</h2>
                    </div>
                    <Row style={{ gap: "2%", justifyContent: "center" }}>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Lunes}
                              onChange={(e) => {
                                setLunes(e.target.checked);
                                if (
                                  !e.target.checked &&
                                  !Martes &&
                                  !Miercoles &&
                                  !Jueves &&
                                  !Viernes &&
                                  !Sabado &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Lunes'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Martes}
                              onChange={(e) => {
                                setMartes(e.target.checked);
                                if (
                                  !Lunes &&
                                  !e.target.checked &&
                                  !Miercoles &&
                                  !Jueves &&
                                  !Viernes &&
                                  !Sabado &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Martes'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Miercoles}
                              onChange={(e) => {
                                setMiercoles(e.target.checked);
                                if (
                                  !Lunes &&
                                  !Martes &&
                                  !e.target.checked &&
                                  !Jueves &&
                                  !Viernes &&
                                  !Sabado &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Miercoles'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Jueves}
                              onChange={(e) => {
                                setJueves(e.target.checked);
                                if (
                                  !Lunes &&
                                  !Martes &&
                                  !Miercoles &&
                                  !e.target.checked &&
                                  !Viernes &&
                                  !Sabado &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Jueves'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Viernes}
                              onChange={(e) => {
                                setViernes(e.target.checked);
                                if (
                                  !Lunes &&
                                  !Martes &&
                                  !Miercoles &&
                                  !Jueves &&
                                  !e.target.checked &&
                                  !Sabado &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Viernes'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Sabado}
                              onChange={(e) => {
                                setSabado(e.target.checked);
                                if (
                                  !Lunes &&
                                  !Martes &&
                                  !Miercoles &&
                                  !Jueves &&
                                  !Viernes &&
                                  !e.target.checked &&
                                  !Domingo
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Sabado'}
                        />
                      </Row>
                      <Row>
                        <FormControlLabel
                          control={
                            <MUICheckbox
                              checked={Domingo}
                              onChange={(e) => {
                                setDomingo(e.target.checked);
                                if (
                                  !Lunes &&
                                  !Martes &&
                                  !Miercoles &&
                                  !Jueves &&
                                  !Viernes &&
                                  !Sabado &&
                                  !e.target.checked
                                ) {
                                  setHorarioInicioSemana("");
                                  setHorarioFinSemana("");
                                }
                              }}
                            sx={checkboxColorStyle}
                            />
                          }
                          label={'Domingo'}
                        />
                      </Row>
                    </Row>
                    <Row
                      style={{
                        justifyContent: "center",
                        gap: "1%",
                        marginTop: "2%",
                        //alignItems: "center",
                      }}
                    >
                      <div style={{ width: '20%'}}>
                        <Box>
                          <Label>Seleciona tu Horario</Label>
                          <TimePicker.RangePicker
                            style={{ width: "100%" }}
                            value={[
                              !!HorarioInicioSemana &&
                                HorarioInicioSemana !== "00:00:00" &&
                                HorarioInicioSemana.substring(0, 3) !== "00:00"
                                ? dayjs(HorarioInicioSemana, "h:mm A")
                                : "",
                              !!HorarioFinSemana &&
                                HorarioFinSemana !== "00:00:00" &&
                                HorarioFinSemana.substring(0, 3) !== "00:00"
                                ? dayjs(HorarioFinSemana, "h:mm A")
                                : "",
                            ]}
                            use12Hours={true}
                            format="h:mm A"
                            onChange={(e) => {
                              setHorarioInicioSemana(e[0].format("h:mm A"));
                              setHorarioFinSemana(e[1].format("h:mm A"));
                            }}
                            disabled={
                              Lunes ||
                                Martes ||
                                Miercoles ||
                                Jueves ||
                                Viernes ||
                                Sabado ||
                                Domingo
                                ? false
                                : true
                            }
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={anotherSchedule}
                                onChange={handleChangeSwitch}
                                name="gilad"
                                sx={swtichColorStyle} />
                            }
                            label="Otra disponibilidad"
                          />
                          {
                            anotherSchedule ? (
                              <TimePicker.RangePicker
                                style={{ width: "100%" }}
                                value={[
                                  !!anotherStartDay &&
                                    anotherStartDay !== "00:00:00" &&
                                    anotherStartDay.substring(0, 3) !== "00:00"
                                    ? dayjs(anotherStartDay, "h:mm A")
                                    : "",
                                  !!anotherEndDay &&
                                    anotherEndDay !== "00:00:00" &&
                                    anotherEndDay.substring(0, 3) !== "00:00"
                                    ? dayjs(anotherEndDay, "h:mm A")
                                    : "",
                                ]}
                                use12Hours={true}
                                format="h:mm A"
                                onChange={(e) => {
                                  setAnotherStartDay(e[0].format("h:mm A"));
                                  setAnotherEndDay(e[1].format("h:mm A"));
                                }}
                                disabled={
                                  Lunes ||
                                    Martes ||
                                    Miercoles ||
                                    Jueves ||
                                    Viernes ||
                                    Sabado ||
                                    Domingo
                                    ? false
                                    : true
                                }
                              />
                            ) : null
                          }
                        </Box>
                      </div>

                      <SelectAntd
                        label="Tiempo de cita:"
                        placeholder="Elige un tiempo de cita"
                        options={[
                          { value: "10", label: "10 Min." },
                          { value: "20", label: "20 Min." },
                          { value: "30", label: "30 Min." },
                          { value: "40", label: "40 Min." },
                          { value: "50", label: "50 Min." },
                          { value: "60", label: "1 Hr." },
                          // { value: "70", label: "1 Hr. 10 Min." },
                          // { value: "80", label: "1 Hr. 20 Min." },
                          // { value: "90", label: "1 Hr. 30 Min." },
                          // { value: "100", label: "1 Hr. 40 Min." },
                          // { value: "110", label: "1 Hr. 50 Min." },
                          // { value: "120", label: "2 Hrs." },
                        ]}
                        style={{ width: "100%" }}
                        setStateValue={setDuracionCita}
                        value={DuracionCita}
                        setStateError={setMensajeDuracionCita}
                        valueError={MensajeDuracionCita}
                        vacio={false}
                      />
                    </Row>
                  </div>
                  <ContenedorBotonCentrado>
                    <ButtonAntd
                      onClick={() => {
                        guardarConfigCita();
                      }}
                    >
                      <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80px" }}>
                        Guardar
                        <CheckCircleIcon style={{ fontSize: "15px" }} />
                      </Row>
                    </ButtonAntd>
                  </ContenedorBotonCentrado>
                </form>
              </div>
            )}

            <form onSubmit={guardarPeriodoBloqueado}>
              <div style={{ textAlign: "center", background: "#fff", padding: "3%", margin: "1% 0", borderRadius: ".5rem" }}>
                <h2>
                  Bloqueo de fecha para citas
                </h2>
                <ContenedorBotonCentrado>
                  <p style={{ paddingBottom: "1.5%" }}>Periodo de fechas</p>
                  <Row
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "1%"
                    }}
                  >
                    <Input
                      type="date"
                      style={{ width: "145px" }}
                      value={FechaInicio}
                      onChange={(e) => {
                        setFechaInicio(e.target.value);
                      }}
                    />
                    <p
                    >
                      A
                    </p>
                    <Input
                      type="date"
                      style={{ width: "145px" }}
                      value={FechaFin}
                      onChange={(e) => {
                        setFechaFin(e.target.value);
                      }}
                    />
                  </Row>
                  <Button htmlType="submit" className="GeneralBoton" style={{ color: "white" }}>
                    <Row style={{ width: "80px", gap: "1%", alignItems: "center", justifyContent: "space-between" }}>
                      Bloquear <LockClockIcon style={{ fontSize: "15px" }} />
                    </Row>
                  </Button>
                </ContenedorBotonCentrado>
              </div>
            </form>

            <Row style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "1%" }}>
              {ListBlockDates.map((fechaBloqueada) => (

                <div
                  style={{
                    display: "flex",
                    background: "white",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "1% 2%",
                    width: "300px",
                    marginBottom: "3px",
                  }}
                >
                  <div>
                    <b>Periodo Bloqueado</b>
                    <p>
                      {fechaBloqueada.FechaInicio} - {fechaBloqueada.FechaFin}
                    </p>
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div>
                    <img
                      onClick={() => {
                        deleteBlockDates(fechaBloqueada.IdBloqueo);
                      }}
                      style={{ width: "18px", cursor: "pointer" }}
                      src={Eliminar}
                      alt=""
                    />
                  </div>
                </div>

              ))}
            </Row>
          </>
        )}
      </Content>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={typeMessage}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}

export default ConfiguracionCitas;
